// @flow

import styled from "styled-components";

export const Container = styled.span`
  display: block;

  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
  `}

  > svg {
    flex-shrink: 0;
    min-width: 24px;
    min-height: 24px;
    border: ${(props) => (props.mandatory ? "1px solid red" : "none")};
    border-radius: 4px;
  }
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  visibility: hidden;
  height: 0;
  width: 0;
`;

export const Label = styled.label`
  position: relative;
  font-size: 14px;
  padding-left: 4px;
  cursor: inherit;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
